<script>
import { langFunction as getLang } from '../../utils/langFunction';

export default {
	inject: [
		'catalogPageLocation'
	],
	methods: {
		getLang
	}
};
</script>

<template>
	<div class="cart-empty">
		<p class="cart-empty__description">{{ getLang('YOUR_BASKET_IS_EMPTY') }}</p>
		<a 
			class="button"
			:href="catalogPageLocation"
		>{{ getLang('PRESS_HERE_TO_CONTINUE_BUTTON') }}</a>
	</div>
</template>

<style scoped>

</style>
